/**
 * ChatAttachments — Container for pending attachment chips.
 *
 * Renders above the textarea in the chat input area.
 * Returns null when there are no attachments.
 */

import { AttachmentChip } from '@/components/assistant/AttachmentChip'
import type { ChatAttachmentState } from '@/types/assistant-attachments'

interface ChatAttachmentsProps {
  attachments: ChatAttachmentState[]
  onRemove: (id: string) => void
}

export function ChatAttachments({ attachments, onRemove }: ChatAttachmentsProps) {
  if (attachments.length === 0) return null

  return (
    <div className="flex flex-wrap gap-1.5 px-3 pt-2">
      {attachments.map((att) => (
        <AttachmentChip
          key={att.id}
          filename={att.filename}
          mimeType={att.mimeType}
          size={att.size}
          status={att.status}
          progress={att.progress}
          // A SharePoint fetch happens server-side, so there is no byte
          // progress to report — the bar pulses rather than lying at 0%.
          indeterminate={att.source === 'sharepoint'}
          source={att.source}
          {...(att.error != null && { error: att.error })}
          onRemove={() => onRemove(att.id)}
        />
      ))}
    </div>
  )
}
